// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1___390f66e0994786951d6{/*!*/}.ToolsMenu-cls2___ed9181821f9a241b5ae{list-style:none;padding:0;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1___390f66e0994786951d6",
	"cls2": "ToolsMenu-cls2___ed9181821f9a241b5ae ToolsMenu-cls1___390f66e0994786951d6"
};
export default ___CSS_LOADER_EXPORT___;
